export interface Theme {
  color?: string[]
  backgroundColor?: string
  textStyle?: {
    color: string
  }
  title?: {
    textStyle?: {
      color?: string
    }
    subtextStyle?: {
      color?: string
    }
  }
  tooltip?: {
    backgroundColor?: string
    textStyle?: {
      color?: string
    }
  }
}

export const darkTheme: Theme = {
  color: ['#00e0ff', '#2fb9ff', '#6ad5ff', '#7bffb8', '#ffd36a', '#ff7b7b', '#a78bff'],
  backgroundColor: '#04122b',
  textStyle: { color: '#bfe9ff' },
  title: { textStyle: { color: '#a6d0ff' }, subtextStyle: { color: '#74c6ff' } },
  tooltip: { backgroundColor: 'rgba(6,36,62,0.9)', textStyle: { color: '#e6f7ff' } }
}

export const lightTheme: Theme = {
  color: ['#3fb1e3', '#6be6c1', '#fddf6b', '#ff7b7b', '#a78bff', '#8bd3ff', '#b6e3ff'],
  backgroundColor: '#ffffff',
  textStyle: { color: '#333' },
  title: { textStyle: { color: '#333' }, subtextStyle: { color: '#666' } }
}
